import { Maybe } from '@aibees/shared/definition';
import { SuggestionSearchBarOptionBase } from '@aibees/elephant/feature/suggestion-search-bar';

export function useSearchInputPlaceholder(
  text: Maybe<string>,
  limitReached: boolean,
  value?: SuggestionSearchBarOptionBase[]
) {
  return !limitReached && !value?.length ? text : '';
}
